import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

/**
 * SmoothScroll クラス
 * ページ内リンク（#id または data-anchor）へスムーススクロールする機能を提供
 */
export default class SmoothScroll {
	constructor() {
		this.init();
	}

	/**
	 * 初期化処理
	 */
	init() {
		this.handleScroll(); // クリック時の処理
		this.handleLoad();   // ページ読み込み時の処理
	}

	/**
	 * ページ内リンクがクリックされたときの処理
	 * <a href="#xxx"> をクリックした場合に、
	 * - id="xxx" を探す
	 * - なければ data-anchor="xxx" を探す
	 */
	handleScroll() {
		$('a[href*="#"]').on('click', function (event) {
			const headerHeight = $('header').height(); // ヘッダー高さ分オフセット
			const hash = this.hash; // 例: "#section2"
			let targetElem = null;

			if (hash) {
				// 1. まず id を優先的に探す
				if ($(hash).length) {
					targetElem = $(hash);
				}
				// 2. id が存在しなければ data-anchor を探す
				else {
					const name = hash.replace('#', ''); // "#section2" → "section2"
					targetElem = $(`[data-anchor="${name}"]`);
				}
			}

			// 対象要素が見つかった場合のみスクロール実行
			if (targetElem && targetElem.length) {
				event.preventDefault(); // デフォルトのジャンプ動作を無効化
				gsap.to(window, {
					duration: 1,
					ease: "power3.inOut",
					scrollTo: {
						y: targetElem,    // スクロール先の要素
						offsetY: headerHeight, // ヘッダー高さ分ずらす
					},
				});
			}
		});
	}

	/**
	 * ページ読み込み時の処理
	 * URLにハッシュが含まれている場合に、
	 * - id を探し、なければ data-anchor を探してスクロール
	 */
	handleLoad() {
		$(window).on('load', () => {
			const headerHeight = $('header').height();
			const hash = window.location.hash; // 例: "#section2"
			let targetElem = null;

			if (hash) {
				// 1. まず id を優先的に探す
				if ($(hash).length) {
					targetElem = $(hash);
				}
				// 2. id が存在しなければ data-anchor を探す
				else {
					const name = hash.replace('#', '');
					targetElem = $(`[data-anchor="${name}"]`);
				}
			}

			// 対象要素が見つかった場合のみスクロール実行
			if (targetElem && targetElem.length) {
				gsap.to(window, {
					duration: 1,
					ease: "power3.inOut",
					scrollTo: {
						y: targetElem,
						offsetY: headerHeight,
					},
				});
			}
		});
	}
}